import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/*
 * Created on Wed Jul 18 2018
 */


import { GenericTransportLayer } from '../GenericTransportLayer';
import { ProductSensitivityConverter } from '@logio/common-be-fe';
import { CONSTANTS } from '../../../constants';
import { Inject } from '@logio/typescript-ioc';
/**
 * @author BPo
 */

export var ProductSensitivityLayer =
/*#__PURE__*/
function (_GenericTransportLaye) {
  _inherits(ProductSensitivityLayer, _GenericTransportLaye);

  function ProductSensitivityLayer() {
    _classCallCheck(this, ProductSensitivityLayer);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductSensitivityLayer).call(this, CONSTANTS.API.ENDPOINTS.PRODUCT_SENSITIVITY));
  }

  _createClass(ProductSensitivityLayer, [{
    key: "getConverter",
    value: function getConverter() {
      return this.converter;
    }
  }]);

  return ProductSensitivityLayer;
}(GenericTransportLayer);

__decorate([Inject, __metadata("design:type", ProductSensitivityConverter)], ProductSensitivityLayer.prototype, "converter", void 0);